import React from 'react'
import { useAppContext } from '@/context/app'
import { getServerTimeZone, isBrowserTimeZoneDifferent } from '@/common/time'
import './TimeZoneNotice.css'

// Informs that daily statistics and reports are calculated for the server time zone.
// It is rendered only when the browser uses another time zone.
export const TimeZoneNotice = () => {
  const { translates } = useAppContext()
  if (!translates || !isBrowserTimeZoneDifferent()) {
    return null
  }
  const text = translates.for('report.timezone_notice', 'Reports and daily statistics are calculated for the {tz} time zone.')
  return <p className='timezone-notice'>{text.replace('{tz}', getServerTimeZone() ?? '')}</p>
}
